import { render, staticRenderFns } from "./AvailableServiceCard.vue?vue&type=template&id=024b1558&"
import script from "./AvailableServiceCard.vue?vue&type=script&lang=js&"
export * from "./AvailableServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./AvailableServiceCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports